const SIGMA_LINK_PREFIX = "oplink_"
export const SIGMA_PAGE_PARAM = "sigmaPage"
export const SIGMA_NODE_ID_PARAM = ":nodeId"

const SIGMA_LINK_NAME_CHARACTERS = "[A-Za-z0-9_-]"

export const SIGMA_LINK_CONTROL_ID_PATTERN = new RegExp(`^${SIGMA_LINK_PREFIX}${SIGMA_LINK_NAME_CHARACTERS}+$`)
export const SIGMA_LINK_PAGE_ID_PATTERN = new RegExp(`^${SIGMA_LINK_NAME_CHARACTERS}+$`)

export const SIGMA_LINK_BLOCKED_WORDS = [
  "key",
  "token",
  "secret",
  "password",
  "passwd",
  "pwd",
  "credential",
  "auth",
  "bearer",
  "jwt",
  "session",
  "cookie",
  "account",
  "user",
  "email",
  "tenant",
  "host",
  "url",
  "endpoint",
  "webhook",
  "bucket",
  "dbfs",
] as const

export const SIGMA_LINK_MAX_NAME_LENGTH = 64
export const SIGMA_LINK_MAX_PAIRS = 30
export const SIGMA_LINK_MAX_VALUE_LENGTH = 2000
export const SIGMA_LINK_MAX_APPENDED_LENGTH = 6000
